(function ($) {
    window.App = {
        ui: {
            w: $(window),
            b: $('body'),
            h: $('.pageHeader'),
            burger: $('.navTrigger'),
            navPanel: $('.pageHeader__nav'),
            searchTrigger: $('.js-search'),
            searchPanel: $('.pageHeader__search'),
            searchClose: $('.js-closesearch'),
            langTrigger: $('.js-triggerlangnav'),
            langPanel: $('.langNav__panel'),
            scrollTop: $('.js-scrollTop')
        },

        state: {},

        mobileCheck: function () {
            var isMobile = {
                Android: function () {
                    return navigator.userAgent.match(/Android/i);
                },
                BlackBerry: function () {
                    return navigator.userAgent.match(/BlackBerry/i);
                },
                iOS: function () {
                    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
                },
                Opera: function () {
                    return navigator.userAgent.match(/Opera Mini/i);
                },
                Windows: function () {
                    return navigator.userAgent.match(/IEMobile/i);
                },
                any: function () {
                    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
                }
            };

            return isMobile.any();
        },

        header: function () {
            let self = this;

            let debounced = _.debounce(function () {
                let vh = window.innerHeight * 0.01;
                self.state.headerHeight = self.ui.h.outerHeight();
                document.documentElement.style.setProperty('--vh', `${vh}px`);
            }, 100);

            debounced();
            $(window).on('resize orientationchange', debounced);

            // bubble current class from sub-menu to menu
            $('.sub-menu .current-menu-item').parents('li').addClass('current-menu-item');
        },

        nav: function () {
            const self = this;

            const closeSearch = function () {
                self.ui.searchPanel.stop().slideUp();
            }

            const closeLang = function () {
                self.ui.langPanel.removeClass('is-opened');
            }

            this.ui.burger.on('click', function (e) {
                e.preventDefault();
                self.ui.b.toggleClass('is-navexpanded');
            });

            $('.js-togglesubmenu').on('click', function (e) {
                e.preventDefault();

                let prnt = $(this).parent();

                if (prnt.hasClass('is-expanded')) {
                    prnt.removeClass('is-expanded');
                    prnt.find('ul.sub-menu').stop().slideUp();
                } else {
                    prnt.addClass('is-expanded');
                    prnt.find('ul.sub-menu').stop().slideDown();
                }
            });

            this.ui.searchTrigger.on('click', function (e) {
                e.preventDefault();
                closeLang();

                if (self.ui.searchPanel.is(':visible')) {
                    self.ui.searchPanel.stop().slideUp();
                } else {
                    if (window.innerWidth >= 1200) {
                        self.ui.searchPanel.css({
                            width: $('.futureEventBar__date').outerWidth() + $('.pageHeader__nav').width()
                        });
                    } else {
                        self.ui.searchPanel.css({
                            width: '100%'
                        });
                    }
                    self.ui.searchPanel.stop().slideDown();
                }
            });

            this.ui.searchClose.on('click', function (e) {
                e.preventDefault();

                closeSearch();
            });

            this.ui.langTrigger.on('click', function (e) {
                e.preventDefault();

                closeSearch();
                self.ui.langPanel.toggleClass('is-opened');
            });

            this.ui.scrollTop.on('click', function (e) {
                e.preventDefault();

                $('body, html').stop().animate({
                    scrollTop: 0
                }, 300);
            });
        },

        headerSlides: function () {
            if (!document.querySelector('.contentHeader__slides')) return;

            let word_left = 'left';
            let word_right = 'right';
            if (this.ui.b.hasClass('rtl')) {
                word_left = 'right';
                word_right = 'left';
            }

            let carousel = tns({
                container: '.contentHeader__slides',
                items: 1,
                slideBy: 'page',
                mode: 'gallery',
                speed: 1000,
                // animateIn: 'fadeIn',
                animateOut: 'fadeOut',
                controls: false,
                controlsText: ['<em class="icon-arrowbtn-' + word_left + '"></em><span class="wcaglabel">prev</span>', '<em class="icon-arrowbtn-' + word_right + '"></em><span class="wcaglabel">next</span>'],
                responsive: {
                    992: {
                        controls: false
                    }
                }
            });

            $('.contentHeader__slides .tns-controls-prev').on('click', function (e) {
                e.preventDefault();
                carousel.goTo('prev');
            });

            $('.contentHeader__slides .tns-controls-next').on('click', function (e) {
                e.preventDefault();
                carousel.goTo('next');
            });
            setInterval(function () { carousel.goTo('next'); }, 4000);
        },

        calendarSlides: function () {
            let nav = $('.clndr__nav button');
            let container = $('.clndr__tab');
            let textboxes = container.find('.calBox__text');

            if (!container.length) return;

            let word_left = 'left';
            let word_right = 'right';

            let cls = tns({
                container: '.clndr__tab',
                items: 1,
                lazyload: true,
                speed: 1000,
                controlsPosition: 'bottom',
                nav: false,
                gutter: 37,
                loop: false,
                controlsText: ['<em class="icon-arrowbtn-' + word_left + '"></em><span class="wcaglabel">prev</span>', '<em class="icon-arrowbtn-' + word_right + '"></em><span class="wcaglabel">next</span>'],
                responsive: {
                    576: {
                        items: 1.5
                    },
                    768: {
                        items: 3
                    },
                    992: {
                        items: 3,
                        gutter: 50
                    },
                    1550: {
                        items: 4
                    }
                }
            });

            nav.on('click', function (e) {
                e.preventDefault();
                let me = $(this);

                nav.removeClass('active');
                me.addClass('active');

                let index = container.find('[data-y="' + me.data('y') + '"]').eq(0).index();
                console.log(index);
                cls.goTo(index)
            });

            cls.events.on('indexChanged', function () {
                let info = cls.getInfo();
                console.log(info.index);
                let yr = info.slideItems[info.index].getAttribute('data-y');
                console.log(yr);

                nav.removeClass('active');
                nav.filter('[data-y="' + yr + '"]').addClass('active');
            });

            let debounced = _.debounce(function () {
                textboxes.removeAttr('style');
                setTimeout(() => {
                    let h = 0;

                    textboxes.each(function () {
                        let localh = $(this).height();
                        if (localh > h) h = localh;
                    });

                    textboxes.css('height', h);
                    cls.refresh();
                }, 100);
            });

            debounced();
            $(window).on('resize', debounced);
        },

        videoblogSlides: function () {
            tns({
                container: '.videoBlog__videoItems',
                items: 1.2,
                // slideBy: 'page',
                // mode: 'gallery',
                speed: 1000,
                controlsPosition: 'bottom',
                nav: false,
                loop: false,
                controls: false,
                mouseDrag: true,
                responsive: {
                    576: {
                        items: 2
                    },
                    1200: {
                        items: 3
                    },
                    1550: {
                        items: 4
                    }
                }
            });
        },

        debug: function () {
            let d = $('#debug');
            if (!d.length) return;

            d.html(window.innerWidth + ' x ' + window.innerHeight + ' px');
            $(window).on('resize', function () {
                d.html(window.innerWidth + ' x ' + window.innerHeight + ' px');
            });
        },

        expanders: function () {
            $('.js-toggleExpand').on('click', function (e) {
                e.preventDefault();

                let me = $(this),
                    wrap = me.parents('.js-expander'),
                    content = wrap.find('.js-expandercontent');

                if (wrap.hasClass('is-expanded')) {
                    wrap.removeClass('is-expanded');
                    content.stop().slideUp();
                } else {
                    wrap.addClass('is-expanded');
                    content.stop().slideDown();
                }
            });
        },

        article: function () {
            // if (! $('.mediaBox__slides').length) return;

            let sidebars = $('.article__sidebars'),
                overflowables = $('.js-overflowable');
            let imgs = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff'];

            $('.pswpCarousel').each(function () {
                new PswpCarousel($(this));
            });

            $('.pswpCarouselNew').each(function () {
                new PswpCarouselNew($(this));
            });

            // console.log($('img[class*="wp-image"]'));
            $('img[class*="wp-image"]').each(function () {
                let me = $(this);
                if (me.parent().prop('nodeName') == 'A') {
                    let url = me.parent().attr('href').slice(-3);
                    console.log(url);
                    if (imgs.indexOf(url) < 0) return;

                    new PswpSingle(me.parent());
                }
            });

            let debounced = _.debounce(function () {
                let offset = sidebars.offset().top + sidebars.outerHeight() + 30;

                overflowables.each(function () {
                    let me = $(this),
                        meoffset = me.offset().top;

                    if (meoffset < offset) {
                        me.removeClass('overflowed');
                    } else {
                        me.addClass('overflowed');
                    }
                });
            });

            debounced();

            $(window).on('resize', debounced);
        },


        forms: function () {
            $('select').selectric({
                multiple: {
                    separator: ', ',
                    keepMenuOpen: true
                }
            });
        },

        players: function () {
            // $('audio, video').mediaelementplayer();
        },

        // pdf() {
        //     $('.js-postpdf').on('click', function(e) {
        //         e.preventDefault();
        //         let me = $(this);

        //         $.ajax({
        //             action: 'GET',
        //             url: window.ajaxurl,
        //             data: {
        //                 action: 'generate_pdf',
        //                 pid: me.data('pid'),
        //                 headless: '1'
        //             }
        //         });
        //     });
        // },

        zip: function () {
            let self = this;

            $('.js-dlall').on('click', function (e) {
                e.preventDefault();
                let me = $(this);

                me.blur();
                let pid = me.data('pid');
                let progressContainer = $('.attchsBox__progress');
                let progressbar = $('.attchsBox__progressbar span');

                if (self.state.downloading) return;

                self.state.downloading = true;
                progressbar.css('width', '0%');
                progressContainer.show();

                $.ajax({
                    url: window.ajaxurl,
                    cache: false,
                    xhr: function () {
                        var xhr = new window.XMLHttpRequest();

                        xhr.onloadstart = function () {
                            xhr.responseType = "blob";
                        }
                        // xhr.responseType = "blob";

                        xhr.addEventListener('progress', function (evt) {
                            if (evt.lengthComputable) {
                                var percentComplete = evt.loaded / evt.total;
                                percentComplete = parseInt(percentComplete * 100);

                                progressbar.css('width', percentComplete + '%');
                            }
                        }, false);

                        return xhr;
                    },
                    type: 'GET',
                    data: {
                        action: 'get_zip',
                        pid: pid
                    },
                    success: function (data) {
                        self.state.downloading = false;
                        progressContainer.hide();
                        var a = document.createElement('a');
                        var url = window.URL.createObjectURL(data);
                        a.href = url;
                        a.download = me.data('title') + '.zip';
                        document.body.appendChild(a);
                        console.log('click');
                        a.click();
                        a.remove();
                        window.URL.revokeObjectURL(url);
                    },
                    error: function (error) {
                        console.log(error);
                        self.state.downloading = false;
                        progressContainer.hide();
                    }
                })
            });
        },

        wcag() {
            $('.js-switch-hc').on('click', function (e) {
                e.preventDefault();

                let isOn = Cookies.get('hcv');
                console.log(isOn);

                if (isOn == '1') {
                    Cookies.remove('hcv');
                    $('html').removeClass('hc');
                } else {
                    Cookies.set('hcv', '1', { expires: 30, path: '/' });
                    $('html').addClass('hc');
                }
            });
        },

        init: function () {
            const ismobile = this.mobileCheck();
            let self = this;

            window.ismobile = ismobile;
            if (ismobile) {
                this.ui.b.addClass('is-mobile');
            } else {
                this.ui.b.addClass('is-desktop');
            }

            if (navigator.userAgent.match(/Webkit/i)) {
                this.ui.b.addClass('is-webkit');
            }

            this.nav();
            this.debug();
            this.expanders();
            this.article();
            this.forms();
            this.headerSlides();
            // this.players();
            this.zip();

            this.wcag();

            if (window._mgw_ishome) {
                this.calendarSlides();
                this.videoblogSlides();
            }

            $(window).on('load', function () {
                // self.lazyload();
                // console.log('window onload');

            });
        }
    }


    $(document).ready(() => {
        App.init();
    });

    $(window).on('load', function () {
        // self.lazyload();
        // console.log('window onload 2');

        setTimeout(function () {
            $('audio, video').mediaelementplayer();
        }, 1);
    });
})(jQuery);
